/**
* Window scroll
*/
const windowScroll = ( top: number = 0, left: number = 0, smooth: boolean = true ): void => {
    window.scroll({
        top: top, 
        left: left, 
        behavior: smooth ? 'smooth' : 'auto'
    });
}

interface paramClass{
    domElement: HTMLElement;
    classList: string;
}
/**
 * Add class
 */
const addClass = (Obj: paramClass) => {
    Obj.domElement.classList.add(Obj.classList);
}
/**
 * Remove class
 */
const removeClass = (Obj: paramClass) => {
    Obj.domElement.classList.remove(Obj.classList);
}
/**
 * Toggle class
 */
const toggleClass = (Obj: paramClass) => {
    Obj.domElement.classList.toggle(Obj.classList);
}

export {
    windowScroll,
    addClass,
    removeClass,
    toggleClass,
}